const DEFAULT_MAX = 200;
const COLORS = ["#D1232A", "#D0492C", "#D08329", "#CDA72A", "#B6BB3B", "#9AB93B", "#81BC3C", "#40AE49"];

export const getArrowColor = (value) => {
    if (value < 17) {
        return COLORS[0];
    }

    if (value < 30) {
        return COLORS[1];
    }

    if (value < 43) {
        return COLORS[2];
    }

    if (value < 55) {
        return COLORS[3];
    }

    if (value < 68) {
        return COLORS[4];
    }

    if (value < 80) {
        return COLORS[5];
    }

    if (value < 94) {
        return COLORS[6];
    }

    return COLORS[7];
};

export const isOverlapping = (val1, val2) => Math.abs(val1 - val2) < 10;

export const buildInfo = ({ aecBeforeRetrofit, typicalNewHome, aecPostRetrofit, pvProduction }) => {
    const infoToRender = [];

    const MAX_VALUE = Math.max(DEFAULT_MAX, aecBeforeRetrofit, typicalNewHome);

    const aecBeforeRetrofitTop = Number((((MAX_VALUE - aecBeforeRetrofit) / MAX_VALUE) * 100).toFixed(0));
    const aecPostRetrofitTop = Number((((MAX_VALUE - aecPostRetrofit) / MAX_VALUE) * 100).toFixed(0));
    const typicalNewHomeTop = Number((((MAX_VALUE - typicalNewHome) / MAX_VALUE) * 100).toFixed(0));
    const pvProductionTop =
        pvProduction > 0
            ? Number((((MAX_VALUE - Math.max(0, aecPostRetrofit - pvProduction)) / MAX_VALUE) * 100).toFixed(0))
            : 0;

    infoToRender.push({
        label: "Before Retrofit",
        value: aecBeforeRetrofit.toFixed(0),
        top: aecBeforeRetrofitTop,
        color: getArrowColor(aecBeforeRetrofitTop),
    });
    infoToRender.push({
        label: "After Retrofit",
        value: aecPostRetrofit.toFixed(0),
        top: aecPostRetrofitTop,
        color: getArrowColor(aecPostRetrofitTop),
    });
    infoToRender.push({
        label: "Typical New Home",
        value: 98,
        top: typicalNewHomeTop,
        color: getArrowColor(typicalNewHomeTop),
    });

    if (pvProductionTop > 0) {
        infoToRender.push({
            label: "PV Production",
            value: Math.max(0, aecPostRetrofit - pvProduction).toFixed(0),
            top: pvProductionTop,
            color: getArrowColor(pvProductionTop),
        });
    }

    return infoToRender;
};
